import React from 'react'
import IconButton from 'components/shared/icon-button'
import * as Icons from 'lucide-react'

interface SidebarDrawerProps {
    haveNavbar: boolean
    sidebarContent?: JSX.Element
    open: boolean
    setOpen: (val: boolean) => void
}
const MobileSidebarDrawer = ({ open, sidebarContent, setOpen }: SidebarDrawerProps) => {
    if (open)
        return (
            <div className="w-[280px] flex flex-col bg-white  fixed h-full top-0 z-50 max-h-screen flex sm:hidden border-r">
                <IconButton className="self-center mt-2" onClick={() => setOpen(false)}>
                    <Icons.X />
                </IconButton>
                {sidebarContent}
            </div>
        )
    else return <></>
}

export default MobileSidebarDrawer
